export const iconFontAwesomeFoodBeverageLemon = (
	<i className="fa-solid fa-lemon"></i>
);
